const SUGGESTIONS = [
  "Which clusters look most worth investigating this week?",
  "Show every advertisement connected to +91 98450 11220",
  "Summarise the @royal_arrangements_blr group",
  "Explain why ad 1002 received a high risk score",
];

export function SuggestionSidebar({ onPick, disabled }) {
  return (
    <aside
      className="border border-slate-200 bg-white rounded-md p-4 space-y-3 h-fit"
      data-testid="assistant-suggestions"
    >
      <h2 className="font-display font-bold text-lg tracking-tight">
        Suggested questions
      </h2>
      <ul className="space-y-2">
        {SUGGESTIONS.map((s, i) => (
          <li key={s}>
            <button
              data-testid={`suggestion-${i}`}
              onClick={() => onPick(s)}
              disabled={disabled}
              className="w-full text-left text-sm border border-slate-200 hover:bg-slate-50 px-3 py-2 rounded-md disabled:opacity-60"
            >
              {s}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}
